"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssertionError = void 0;
exports.assert = assert;
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message, details) {
        if (details === void 0) { details = null; }
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        _this.message = message;
        if (Error.captureStackTrace) {
            // second param - local context. Will not be displayed in stack
            Error.captureStackTrace(_this, details && details.contextFn);
        }
        else if (!_this.stack) {
            try {
                throw new Error();
            }
            catch (ex) {
                _this.stack = ex.stack;
            }
        }
        _this.details = details;
        return _this;
    }
    return AssertionError;
}(Error));
exports.AssertionError = AssertionError;
function assert(condition, message, details) {
    if (details === void 0) { details = null; }
    if (!condition) {
        throw new AssertionError(message, details);
    }
}
//# sourceMappingURL=assert.js.map